import { useEffect, useState } from 'react';

import { useOnceReveal } from '@common/hooks';

interface LazyIframeProps {
  width: string;
  height: string;
  source: string;
  title?: string;
  style?: React.CSSProperties;
}

export const LazyIframe = ({ source, width, height, title, style }: LazyIframeProps) => {
  const [src, setSrc] = useState('');
  const { targetRef, isRevealed } = useOnceReveal();

  useEffect(() => {
    if (isRevealed) {
      setSrc(source);
    }
  }, [isRevealed]);

  return <iframe title={title ?? '상품정보'} width={width} height={height} src={src} ref={targetRef} style={style} />;
};
